import {storeInstance} from '@aofl/store/dist/legacy';
import {sdoNs} from './constants-enumerate';
import {ApiService} from './api-service';
import {tierStructure} from './i18n-labels';

const arrayIterator = function* gen(arr) {
  yield* arr;
};

class GroupLevelsFilter {
  constructor(maxLevel, showClasses = false, showThirdPartyConnected = true) {
    this.groups = [];
    this.allGroups = {};
    this.maxLevel = maxLevel;
    this.showClasses = showClasses;
    this.showThirdPartyConnected = showThirdPartyConnected;
    if (typeof maxLevel !== 'number') {
      throw new TypeError(`${this.constructor.name}.maxLevel: ${typeof maxLevel} is not a number`);
    }

    const state = storeInstance.getState();
    const orgMaxLevel = parseInt(state[sdoNs.SESSION].settings.tier_structure.levels, 10);
    if (maxLevel === orgMaxLevel && showClasses === true) {
      this.maxLevel += 1;
    } /** @todo needs to be fixed once api fixes their part or not */
  }

  _setSelected(subGroups, myGroups, levelLabelOverrides) {
    for (const [groupId, groupInfo] of Object.entries(subGroups)) {
      subGroups[groupId].selected = 0;
      subGroups[groupId].tier = (myGroups[parseInt(groupInfo.level, 10) + 1] || {label: tierStructure.CLASS}).label;
      subGroups[groupId].label = levelLabelOverrides?.[groupInfo.level] || '';
      if (groupInfo.hasOwnProperty('groups')) {
        subGroups[groupId].groups = Object.values(groupInfo.groups);
        this._setSelected(groupInfo.groups, myGroups, levelLabelOverrides);
      }
    }
  }

  async loadAllGroupsByParentPath(groupInfo, levelLabelOverrides) {
    const state = storeInstance.getState();
    const myGroups = state[sdoNs.SESSION].$myGroups;
    storeInstance.commit({
      namespace: sdoNs.SESSION,
      mutationId: 'setSelectedGroup',
      payload: groupInfo
    });
    const nestedGroups = await ApiService.groupListNestedByParent(groupInfo.id, this.showThirdPartyConnected);
    let subGroups;
    if (typeof nestedGroups.groups !== 'undefined') {
      subGroups = nestedGroups.groups[groupInfo.id].groups || nestedGroups.groups;
      this._setSelected(subGroups, myGroups, levelLabelOverrides);
      for (const [groupId, groupInfo] of Object.entries(subGroups)) {
        if (groupInfo.hasOwnProperty('groups')) {
          this._setSelected(groupInfo.groups, myGroups, levelLabelOverrides);
        }
      }
      this.allGroups = {
        id: groupInfo.id,
        name: groupInfo.name,
        path: groupInfo.path,
        level: groupInfo.level,
        selected: 0,
        label: levelLabelOverrides?.[groupInfo.level] || '',
        tier: (myGroups[parseInt(groupInfo.level, 10) + 1] || {label: tierStructure.CLASSES}).label,
        groups: Object.values(subGroups)
      };
    }
    return (subGroups) ?
      this.addGroupLevel(this.allGroups, groupInfo.level) :
      [];
  }

  getSelectedGroup() {
    if (this.groups.length) {
      const lastGroup = this.groups[this.groups.length - 1];
      return lastGroup.group_id;
    }
    const state = storeInstance.getState();
    return state[sdoNs.SESSION].current_role.group_id;
  }

  addGroupLevel(groupInfo, groupIndex) {
    let groupData;
    if (groupInfo.type === 'classroom') {
      groupData = {
        groups: [groupInfo],
      };
    } else {
      groupData = groupInfo;
    }
    if (groupData?.groups?.length) {
      this.groups = [
        ...this.groups.slice(0, groupIndex),
        groupData
      ];
    }
    return this.groups;
  }

  updateGroup(groupIndex, selectedGroup) {
    const groupData = {
      ...this.groups[groupIndex],
      selected: selectedGroup.id,
      label: selectedGroup.name
    };
    this.groups = [
      ...this.groups.slice(0, groupIndex),
      groupData
    ];
    // now saving all the group data in the selectedGroup key
    storeInstance.commit({
      namespace: sdoNs.SESSION,
      mutationId: 'setSelectedGroup',
      payload: selectedGroup
    });
    // This is the fix for school-level admins
    if (selectedGroup.level < this.maxLevel) {
      return this.addGroupLevel(selectedGroup, groupIndex + 1);
    }
    return Promise.resolve(this.groups);
  }

  loadSelectedGroups(selectedGroups) {
    return new Promise((resolve, reject) => {
      const selectedGroupsIterator = arrayIterator(selectedGroups);
      let index = 0;

      const loadNextGroup = async (iter) => {
        const next = iter.next();
        if (next.done) return resolve(this.groups);
        if (index < this.groups.length) {
          const itemIndex = this.groups[index].groups.findIndex((item) => item.id === selectedGroups[index]);
          if (itemIndex > -1) {
            const selectedGroup = this.groups[index].groups[itemIndex];
            this.updateGroup(index, selectedGroup);
          }
        }
        index += 1;
        loadNextGroup(selectedGroupsIterator);
      };

      loadNextGroup(selectedGroupsIterator);
    });
  }
}

export {
  GroupLevelsFilter
};
